import { Types } from '../actionTypes'
import { clearAuth } from '../../api/api'

const initialState = {
  id: 0,
  companies: [],
  visit_destinations: [],
  identification: '',
  first_name: '',
  last_name: '',
  email: '',
  card_number: '',
  tag_number: '',
  beacon: '',
  team: [],
  groups: [],
  next_assistance_date: '',
  preferentialAccess: false,
  domain: 'public',
  goHome: 0,
  enabled_parking: false,
  enabled_workplace: false,
  enabled_parking_schedule: false,
  enabled_room_reservations: false,
  has_accepted_privacy_policy: false,
  enabled_manual_checkin: false,
  enabled_visits: false,
  firebase_token: '',
  qrCode: '',
  company: {
    enabled_desk_reservations: false,
    max_future_days_to_reserve: 60,
    workplace_max_future_days_to_reserve: 60,
    show_desk_reservation_reason: false,
    enabled_multiples_parking_reservations: false, //selección de rango de horas en una misma reserva
    enabled_multiples_parking_days_reservations: false,  //selección de multiples días en una misma reserva
    parking_reservations_multiples_offset: 0,
    enabled_cafeteria: false,
    parking_reservation_reschedule_offset: 5,
    enabled_parking_checkin_geolocalization: true,
    enabled_desk_checkin_geolocalization: true,
    enabled_room_checkin_geolocalization: true
  },
  logo: ''
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_DOMAIN:
      const domain = action.payload
      state.domain = domain
      localStorage.setItem('domain', domain)
      return state
    case Types.SET_AUTH:
      const {
        id = 0,
        identification = '',
        first_name = '',
        last_name = '',
        email = '',
        card_number = '',
        tag_number = '',
        beacon = '',
        graph_user_id = '',
        has_accepted_privacy_policy = false,
        preferentialAccess = false
      } = action.payload.data

      const goHome = state.goHome + 1
      const company = action.payload.company
      const groups = action.payload.groups
      const team = action.payload.workplace_group

      const {
        enabled_visits,
        enabled_parking,
        enabled_workplace,
        enabled_parking_schedule,
        enabled_room_reservations,
        enabled_cafeteria,
        enabled_manual_checkin: enabled_desk_reservations_manual_checkin,
        enabled_room_reservations_manual_checkin,
        enabled_desk_assignations_manual_checkin,
        next_assistance_date
      } = action.payload

      let {
        enabled_parking_reservations_manual_checkin,
        enabled_parking_assignations_manual_checkin
      } = action.payload

      if (company.enabled_group_settings) {
        const maxBookingsArr = groups.map(g => Number(g.max_booking_per_person)).filter(n => !isNaN(n))
        company.max_bookings_per_person = maxBookingsArr.length ? Math.max(...maxBookingsArr) : 0

        const maxFutureArr = groups.map(g => Number(g.max_future_days_to_reserve)).filter(n => !isNaN(n))
        company.max_future_days_to_reserve = maxFutureArr.length ? Math.max(...maxFutureArr) : 0

        const minReservationTimeArr = groups.map(g => Number(g.min_parking_reservation_time)).filter(n => !isNaN(n))
        company.min_reservation_time = minReservationTimeArr.length ? Math.min(...minReservationTimeArr) : 0

        enabled_parking_reservations_manual_checkin = groups.some(g => g.enabled_parking_reservations_manual_checkin || false)
        enabled_parking_assignations_manual_checkin = groups.some(g => g.enabled_parking_assignations_manual_checkin || false)
      }

      if (company.enabled_workplace_group_settings) {
        const maxBookingsArr = team.map(g => Number(g.max_booking_per_person)).filter(n => !isNaN(n))
        company.workplace_max_booking_per_person = maxBookingsArr.length ? Math.max(...maxBookingsArr) : 0

        const maxFutureArr = team.map(g => Number(g.max_future_days_to_reserve)).filter(n => !isNaN(n))
        company.workplace_max_future_days_to_reserve = maxFutureArr.length ? Math.max(...maxFutureArr) : 0
      }

      if (company.parking_schedules?.length) {
        company.parking_schedules.sort(
          (a, b) => (a.week_day - b.week_day)
        )
      }

      company.enabled_multiples_parking_days_reservations =
        !company.enabled_multiples_parking_reservations &&
        !enabled_workplace

      return {
        ...state,
        id,
        identification,
        first_name,
        last_name,
        email,
        card_number,
        graph_user_id,
        tag_number,
        beacon,
        company,
        team,
        groups,
        preferentialAccess,
        has_accepted_privacy_policy,
        goHome,
        enabled_parking,
        enabled_workplace,
        enabled_parking_schedule,
        enabled_room_reservations,
        enabled_desk_reservations_manual_checkin,
        enabled_parking_reservations_manual_checkin,
        enabled_room_reservations_manual_checkin,
        enabled_parking_assignations_manual_checkin,
        enabled_desk_assignations_manual_checkin,
        enabled_visits,
        enabled_cafeteria,
        next_assistance_date
      }
    case Types.CLEAN_AUTH:
      clearAuth()
      return initialState
    case Types.SET_LOGO:
      const { logo } = action.payload
      return { ...state, logo }
    case Types.SET_FIREBASE_TOKEN:
      const firebase_token = action.payload
      return { ...state, firebase_token }
    case Types.SET_QRCODE:
      const qrCode = action.payload
      return { ...state, qrCode }
    case Types.SET_TRUE_HAS_ACCEPTED_PRIVACY_POLICY:
      return { ...state, has_accepted_privacy_policy: true }
    case Types.SET_TRUE_GRAPH_USER_ID:
      return { ...state, graph_user_id: true }
    case Types.SET_COMPANIES:
      const companies = action.payload
      return { ...state, companies }
    case Types.SET_VISIT_DESTINATIONS:
      const visit_destinations = action.payload
      return { ...state, visit_destinations }     
    default:
      return state
  }
}

export default reducer;